
import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { CommonService } from '@/services'
@Component({
    components: {}
})
export default class extends Vue {
    private typeId = -1
    private loading = false
    private isLoading = true

    private async mounted() {
        this.typeId = +this.$route.params.id
        const exist = await this.getDetail()
        this.isLoading = false
        if (!exist) this.$merror('找不到该分类!')
    }

    private form = {
        name: ''
    }
    private rules = {
        name: [{ required: true, message: '请输入类型名称', trigger: 'blur' }]
    }
    get formRef() {
        return this.$refs.createTypeRef as ElForm
    }
    private stripPrefix(name: string) {
        return name.replace(/^酷公司\//, '')
    }
    async getDetail() {
        const result = await CommonService.getIArticleTypes({})
        let isExist = false
        if (result.status === 200) {
            if (result.data.length) {
                result.data.map((type: any) => {
                    if (+type.id === this.typeId) {
                        this.$set(this.form, 'name', this.stripPrefix(type.name))
                        isExist = true
                    }
                })
            }
        }
        return isExist
    }

    onEdit() {
        this.formRef.validate(async valid => {
            if (valid) {
                const isCoolCompany = this.$route.name === 'ContentCoolCompanyTypeDetail'
                const name = isCoolCompany ? `酷公司/${this.form.name}` : this.form.name

                const params = {
                    id: this.typeId,
                    name
                }
                this.loading = true
                const result = await CommonService.updateIArticleType(params)
                if (result.status === 200) {
                    this.$msuccess('修改成功!')
                }
                this.loading = false
            }
        })
    }
}
